var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.approveShow && !_vm.expenseShow) ? _c('div', {
    staticClass: "dashboard-content"
  }, [_c('el-row', {
    staticStyle: {
      "margin": "36px 20px 0 20px"
    }
  }, [_c('el-col', {
    staticClass: "state",
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "state-wrap",
    on: {
      "click": function($event) {
        return _vm.stateClick(0)
      }
    }
  }, [_c('div', {
    staticClass: "state-left"
  }, [_c('div', {
    staticClass: "state-text"
  }, [_vm._v("待处理")]), _vm._v(" "), _c('div', {
    staticClass: "state-number"
  }, [_vm._v(_vm._s(_vm.Num.processing))])]), _vm._v(" "), _c('div', {
    staticClass: "state-right"
  }, [_c('img', {
    staticClass: "state-img",
    attrs: {
      "src": require("../../../assets/oa/state-orange.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('el-col', {
    staticClass: "state",
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "state-wrap",
    on: {
      "click": function($event) {
        return _vm.stateClick(1)
      }
    }
  }, [_c('div', {
    staticClass: "state-left"
  }, [_c('div', {
    staticClass: "state-text"
  }, [_vm._v("已发起")]), _vm._v(" "), _c('div', {
    staticClass: "state-number"
  }, [_vm._v(_vm._s(_vm.Num.my))])]), _vm._v(" "), _c('div', {
    staticClass: "state-right"
  }, [_c('img', {
    staticClass: "state-img",
    attrs: {
      "src": require("../../../assets/oa/state-green.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('el-col', {
    staticClass: "state",
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "state-wrap",
    on: {
      "click": function($event) {
        return _vm.stateClick(2)
      }
    }
  }, [_c('div', {
    staticClass: "state-left"
  }, [_c('div', {
    staticClass: "state-text"
  }, [_vm._v("已处理")]), _vm._v(" "), _c('div', {
    staticClass: "state-number"
  }, [_vm._v(_vm._s(_vm.Num.processed))])]), _vm._v(" "), _c('div', {
    staticClass: "state-right"
  }, [_c('img', {
    staticClass: "state-img",
    attrs: {
      "src": require("../../../assets/oa/state-blue.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('el-col', {
    staticClass: "state",
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "state-wrap",
    on: {
      "click": function($event) {
        return _vm.stateClick(3)
      }
    }
  }, [_c('div', {
    staticClass: "state-left"
  }, [_c('div', {
    staticClass: "state-text"
  }, [_vm._v("我收到")]), _vm._v(" "), _c('div', {
    staticClass: "state-number"
  }, [_vm._v(_vm._s(_vm.Num.myHandle))])]), _vm._v(" "), _c('div', {
    staticClass: "state-right"
  }, [_c('img', {
    staticClass: "state-img",
    attrs: {
      "src": require("../../../assets/oa/state-blue-two.png"),
      "alt": ""
    }
  })])])])], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "position": "relative",
      "padding": "20px 0 0 30px"
    },
    attrs: {
      "inline": true,
      "model": _vm.ruleForm
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-collapse', {
    staticClass: "collapse",
    staticStyle: {
      "margin": "0 30px"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.List), function(item) {
    return _c('el-collapse-item', {
      key: _vm.id,
      attrs: {
        "name": item.approval_process_type
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      staticClass: "collapse-title"
    }, [_vm._v(_vm._s(item.approval_process_name))]), _vm._v(" "), _c('span', {
      staticClass: "collapse-title-gray"
    }, [_vm._v(_vm._s(item.oaManageSetList.length))])]), _vm._v(" "), _c('div', {
      staticClass: "collapse-wrap"
    }, _vm._l((item.oaManageSetList), function(items) {
      return _c('div', {
        key: _vm.id,
        staticClass: "collapse-module",
        on: {
          "click": function($event) {
            return _vm.collapseClick(items)
          }
        }
      }, [_c('img', {
        staticClass: "collapse-img",
        attrs: {
          "src": require("../../../assets/oa/collapse-img.png"),
          "alt": ""
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "collapse-text"
      }, [_vm._v(_vm._s(items.approval_process_name))])])
    }), 0)], 2)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.approveShow) ? _c('approveCenter', {
    attrs: {
      "stateText": _vm.stateText
    },
    on: {
      "closeBack": function($event) {
        return _vm.closeBack()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.expenseShow) ? _c('expenseReimburse', {
    attrs: {
      "collapseId": _vm.collapseId
    },
    on: {
      "closeBackTwo": function($event) {
        return _vm.closeBackTwo()
      }
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-012a8fdb","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oa/approve/approve.vue
// module id = null
// module chunks = 